module.exports = __webpack_public_path__ + "static/media/solarwaterpumping.362f7fc2.PNG";